namespace GeniuzPOS.PosShift {
    export enum VatRefundDocFg {
        Reciept = 0,
        TaxInvoice = 1
    }
    Serenity.Decorators.registerEnumType(VatRefundDocFg, 'GeniuzPOS.PosShift.VatRefundDocFg');
}
